// extracted by mini-css-extract-plugin
export default {"container":"BimWorkOrderActsKc2_container__gn2iI","innerBlock":"BimWorkOrderActsKc2_innerBlock__4UMM1","overlayLoader":"BimWorkOrderActsKc2_overlayLoader__B9SDw"};